// extracted by mini-css-extract-plugin
export var root = "variables-module--root--RxC2+";